(() => {
  if (window.MOSVsSongwriterLoaded) return;
  window.MOSVsSongwriterLoaded = true;

  const rootSelector = '[data-mos-vs-root]';
  const trackedParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'gbraid',
    'wbraid'
  ];

  const emit = (name, detail = {}) => {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail }));
    } catch (_) {
      // Tracking must never interrupt navigation or playback.
    }
  };

  const pauseOtherMedia = (current) => {
    document.querySelectorAll(`${rootSelector} audio, ${rootSelector} video`).forEach((media) => {
      if (media !== current && !media.paused) media.pause();
    });
  };

  const enhanceLinks = (root) => {
    const currentParameters = new URLSearchParams(window.location.search);

    root.querySelectorAll('a[data-mos-vs-cta]').forEach((link) => {
      if (link.dataset.mosVsEnhanced === 'true') return;
      link.dataset.mosVsEnhanced = 'true';

      try {
        const destination = new URL(link.href, window.location.origin);
        if (destination.origin === window.location.origin) {
          trackedParameters.forEach((parameter) => {
            const value = currentParameters.get(parameter);
            if (value && !destination.searchParams.has(parameter)) {
              destination.searchParams.set(parameter, value);
            }
          });
          link.href = destination.toString();
        }
      } catch (_) {
        // Keep the original crawlable href if URL enhancement is unavailable.
      }

      link.addEventListener('click', () => {
        emit('mos_vs_primary_cta_click', {
          location: link.dataset.mosVsCta || 'unknown'
        });
      });
    });
  };

  const setupMedia = (root) => {
    root.querySelectorAll('audio[data-mos-vs-audio]').forEach((audio) => {
      if (audio.dataset.mosVsReady === 'true') return;
      audio.dataset.mosVsReady = 'true';
      audio.addEventListener('play', () => {
        pauseOtherMedia(audio);
        emit('mos_vs_sample_play', {
          sample: audio.dataset.mosVsSample || ''
        });
      });
    });

    root.querySelectorAll('video[data-mos-vs-video]').forEach((video) => {
      if (video.dataset.mosVsReady === 'true') return;
      video.dataset.mosVsReady = 'true';
      video.addEventListener('play', () => {
        pauseOtherMedia(video);
        emit('mos_vs_reaction_play', {
          reaction: video.dataset.mosVsReaction || ''
        });
      });
    });
  };

  const setupComparisonTracking = (root) => {
    const comparison = root.querySelector('[data-mos-vs-comparison]');
    if (!comparison || comparison.dataset.mosVsObserved === 'true') return;
    comparison.dataset.mosVsObserved = 'true';

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      emit('mos_vs_comparison_view');
      observer.disconnect();
    }, { threshold: 0.25 });
    observer.observe(comparison);
  };

  const setupStickyCta = (root) => {
    const sticky = root.querySelector('[data-mos-vs-sticky]');
    const heroCta = root.querySelector('[data-mos-vs-hero-cta]');
    if (!sticky || !heroCta || sticky.dataset.mosVsReady === 'true') return;
    sticky.dataset.mosVsReady = 'true';

    if (!('IntersectionObserver' in window)) return;

    let heroVisible = true;
    let finalVisible = false;
    let footerVisible = false;
    const finalPanel = document.querySelector('[data-mos-vs-final]');
    const footer = document.querySelector('footer, [data-section-type="footer"]');

    const update = () => {
      sticky.dataset.visible = String(!heroVisible && !finalVisible && !footerVisible);
    };

    new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;
      update();
    }, { threshold: 0 }).observe(heroCta);

    if (finalPanel) {
      new IntersectionObserver(([entry]) => {
        finalVisible = entry.isIntersecting;
        update();
      }, { threshold: 0.05 }).observe(finalPanel);
    }

    if (footer) {
      new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        update();
      }, { threshold: 0 }).observe(footer);
    }

    const setCookieOffset = () => {
      const banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner, [data-cookie-banner]');
      const height = banner && banner.offsetParent !== null ? banner.getBoundingClientRect().height : 0;
      sticky.style.setProperty('--mos-vs-cookie-offset', `${height}px`);
    };
    setCookieOffset();
    window.addEventListener('resize', setCookieOffset, { passive: true });
  };

  const init = (root) => {
    enhanceLinks(root);
    setupMedia(root);
    setupComparisonTracking(root);
    setupStickyCta(root);
  };

  const initAll = () => document.querySelectorAll(rootSelector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.(rootSelector)
      ? event.target
      : event.target.querySelector?.(rootSelector);
    if (root) init(root);
  });
})();
